import React from 'react';
import dayjs from 'dayjs';
import s from './s.module.less';
import MonthDay from '../MonthDay';
import { getDateKey } from 'utils/calendar';
import { Event } from 'types/calendar';
import { KlarityService, Prospect } from 'types/common';

type Props = {
    monthDaysMatrix: dayjs.Dayjs[][];
    dateEventMap: Record<string, Event[]>;
    onEventEdit?: (event: Event) => void;
    timezone?: string;
    onEventAdd?: (start: dayjs.Dayjs, end: dayjs.Dayjs) => void;
    allSpecialityData?: KlarityService[];
    allClients?: Prospect[];
    onEventUpdate?: () => void;
    onEditRefillTask?: (item: any) => void;
};

const Month = (props: Props) => {
    const {
        monthDaysMatrix,
        dateEventMap,
        onEventEdit,
        timezone,
        onEventAdd,
        allSpecialityData,
        allClients,
        onEventUpdate,
        onEditRefillTask,
    } = props;
    return (
        <div className={s.wrap}>
            {monthDaysMatrix.map((row, i) => {
                return (
                    <div className={s.rowWrap} key={i}>
                        {row.map((day, idx) => {
                            const key = getDateKey(day);
                            return (
                                <MonthDay
                                    allSpecialityData={allSpecialityData}
                                    onEventAdd={onEventAdd}
                                    timezone={timezone}
                                    onEventEdit={onEventEdit}
                                    onEventUpdate={onEventUpdate}
                                    onEditRefillTask={onEditRefillTask}
                                    allClients={allClients}
                                    events={dateEventMap[key] || []}
                                    day={day}
                                    key={idx}
                                    rowInx={i}
                                />
                            );
                        })}
                    </div>
                );
            })}
        </div>
    );
};

export default Month;
